import { selectInfoUser } from 'app/pages/App/slice/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useHasComboHolidayAccess = () => {
  const infoUser = useSelector(selectInfoUser);
  const isHasComboHolidayAccess = useMemo(() => {
    return infoUser?.businessPartner?.hasComboHolidayAccess ?? false;
  }, [infoUser?.businessPartner?.hasComboHolidayAccess]);

  return { isHasComboHolidayAccess };
};
